import type { CSSProperties } from 'react';

import { Box, styled, Typography } from '@mui/material';

export const StubWrapper = styled(Box)(() => ({
  width: '100%',
  maxWidth: '320px',
  textAlign: 'center',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '8px',
}));

export const StubContainer = styled(Box, {
  shouldForwardProp: (prop: string) => !['alignItems'].includes(prop),
})<{ alignItems?: CSSProperties['alignItems'] }>(({ theme, alignItems }) => ({
  width: '100%',
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: alignItems || 'center',
  padding: '40px 0 40px 0',
  [theme.breakpoints.down('sm')]: {
    padding: '80px 0 80px 0',
  },
}));

export const StubTitle = styled(Typography)(({ theme }) => ({
  whiteSpace: 'pre-wrap',
  color: theme.palette.case.neutral.n800,
}));
export const StubDescription = styled(Typography)(({ theme }) => ({
  color: theme.palette.case.neutral.n700,
  whiteSpace: 'pre-wrap',
  wordBreak: 'break-word',
}));

export const StubIconWrapper = styled(Box)(() => ({
  width: '100%',
  maxWidth: '240px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  maxHeight: '134px',
  height: '100%',
  marginTop: '8px',

  '&>img': {
    maxWidth: '240px',
    maxHeight: '134px',
  },
}));
